<template>
  <v-select
    v-model="groupsProxy"
    :dense="dense"
    :hide-details="dense"
    :hint="$t('Users.Form.selectGroups')"
    :items="sortedGroups"
    :label="$t('Users.Form.groups')"
    :outlined="outline"
    :persistent-hint="!dense"
    :small-chips="dense"
    chips
    multiple
    item-text="name"
    prepend-inner-icon="groups"
    return-object
    color="primary"
    ref="group-select"
  >
  </v-select>
</template>

<script>
import {UserGroupRepository} from '@portal/api'
export default {
  name: 'GroupSelector',
  props: {
    outline: {type: Boolean, required: false},
    groups: {type: Array, required: true},
    dense: {type: Boolean, required: false, default: false}
  },
  data: () => ({
    groupsList: []
  }),
  computed: {
    sortedGroups () {
      return [...this.groupsList]
      .sort((a, b) => a.name > b.name ? 1 : -1)
    },
    groupsProxy: {
      get () {
        return this.groups
      },
      set (value) {
        this.$emit('update:groups', value)
      }
    }
  },
  async created () {
    this.groupsList = await UserGroupRepository.fetchAll()
  }
}
</script>